import React from 'react';
// material-ui
import { Box, Grid, Typography } from '@mui/material';
import { ViewStream } from '@mui/icons-material';
import Card from './Card';
import BaseInput from '../../component/form/base-input.component';
import { SwitchComponent } from './dish-group-detail';
// models
import { MenuDish, TaxGroup } from '../../models';
// lodash
import _ from 'lodash';
// css
import './scss/menu-dish-detail-multiple.scss';
import { apiManage_rbp } from '../../request';
import GlobalNotification from '../../component/common/snackbar';
import setLoading from '../../component/linear-determinate';
import i18n from '../../i18n';
import { PatchDishesParams } from '../../request/api/rbp/menu';
import ButtonComponent from '../../component/button/button.component';

export default class MenuDishDetailMultiple extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.onSave = _.debounce(this.onSave, 500, {
            leading: true,
            trailing: false
        }).bind(this) as any;
    }

    public state: State = {
        // 不同菜单同一菜品
        dishes: _.cloneDeep(this.props.dishes),
    }

    // *********************
    // Life Cycle Function
    // *********************

    // *********************
    // Default Function
    // *********************
    /**
     * 表单回调
     * @param value
     * @param key [0].name
     * @param originKey name
     */
    onChange(value: number | string | string[], key: string, originKey: string) {
        const { dishes } = this.state;
        let newValue = value;
        // 价格做处理
        if ((originKey === 'price_1') || (originKey === 'rule_lnr_limit_price')) {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = Number(Number(value).toFixed(2))
            }
        }
        // 数量做处理
        if (originKey === 'rule_lnr_max_num' || originKey === 'rule_table_max_num') {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = Number(Number(value).toFixed(0))
            }
        }
        _.set(dishes, key, newValue)
        this.setState({
            dishes
        })
    }

    /**
     * 保存
     */
    async onSave() {
        setLoading(true);
        const params: PatchDishesParams[] = [];
        this.state.dishes.forEach((item) => {
            params.push({
                item_id: item.item_id,
                nlu: item.nlu,
                tax_group: item.tax_group,
                rule_lnr_max_num: item.rule_lnr_max_num,
                rule_table_max_num: item.rule_table_max_num,
                rule_lnr_limit_price: item.rule_lnr_limit_price,
                rule_lnr_limit_enable: item.rule_lnr_limit_enable,
            })
        })
        const result = await apiManage_rbp.patch_dishes(params);
        if (!_.get(result, 'error')) {
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            // 刷新菜单数据
            this.props.getMenuData();
        }
        // 请求失败
        else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
        setLoading(false);
    }

    // *********************
    // View
    // *********************

    render() {
        const { detail } = this.props;
        const { dishes } = this.state;
        // 税率组
        const taxGroup = this.props.taxGroup.map((item) => ({
            label: item.tax_group_name || '',
            value: item.tax_group_id || 0
        }));
        taxGroup.unshift({
            value: -1,
            label: i18n.t('menu_and_dishes_page_not_specified')
        })
        // 表单
        const formArr = [
            {
                key: 'dmi_slu_name',
                label: i18n.t('menu_and_dishes_page_subclass_name'),
                disable: true,
            },
            {
                key: 'item_id',
                label: 'id',
                disable: true,
            },
            {
                key: 'nlu',
                label: i18n.t('rwa_setting_page_mnemonic_code'),
            },
            {
                key: 'tax_group',
                label: i18n.t('tax_group_page_label'),
                type: 'select',
                select: true,
                items: taxGroup
            },
            {
                key: 'rule_lnr_max_num',
                label: i18n.t('menu_and_dishes_page_rule_lnr_max_num'),
                type: 'number'
            },
            {
                key: 'rule_table_max_num',
                label: i18n.t('menu_and_dishes_page_table_max_num'),
                type: 'number'
            },
            {
                key: 'rule_lnr_limit_price',
                label: i18n.t('menu_and_dishes_page_extra_price'),
                type: 'number'
            }
        ]

        return (
            <Card
                className='menu-dish-detail-multiple'
                title={(
                    <Box display='flex' alignItems='center'>
                        <ButtonComponent
                            action='BACK'
                            handleClick={() => {
                                this.props.handleClickBack()
                            }}
                        />
                        <Typography>
                            {i18n.t('menu_and_dishes_page_batch_edit_dishes_detail')} {detail.item_name1}
                        </Typography>
                    </Box>
                )}
                actionRender={(
                    <>
                        <ButtonComponent
                            titleText={i18n.t('menu_and_dishes_page_change_edit_mode')}
                            children={<ViewStream />}
                            handleClick={this.props.handleChangeMode}
                        />
                        <ButtonComponent
                            action='SAVE'
                            handleClick={() => { this.onSave() }}
                        />
                    </>
                )}
                contentRender={(
                    <Grid container spacing={4}>
                        {
                            dishes.map((dishDetail, index) => (
                                <Grid key={dishDetail.item_id} item xs={12} sm={6} md={4}>
                                    <div className='menu-dish-detail-multiple-detail-box base-shadow'>
                                        <Grid container spacing={4}>
                                            {
                                                formArr.map((item) => (
                                                    <Grid item xs={12} key={item.key}>
                                                        <BaseInput
                                                            disabled={item.disable}
                                                            select={item.select}
                                                            items={item.items}
                                                            type={item.type}
                                                            variant={'outlined'}
                                                            fullWidth
                                                            label={item.label}
                                                            value={_.get(dishDetail, item.key) ?? ''}
                                                            onChange={(event) => {
                                                                this.onChange(event.target.value, `[${index}].${item.key}`, item.key)
                                                            }}
                                                        />
                                                    </Grid>

                                                ))
                                            }
                                            <Grid item>
                                                <SwitchComponent
                                                    value={dishDetail.rule_lnr_limit_enable === 1}
                                                    label={i18n.t('menu_and_dishes_page_continue_to_add')}
                                                    onChange={(e, checked) => {
                                                        this.onChange(Number(checked), `[${index}].rule_lnr_limit_enable`, 'rule_lnr_limit_enable')
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>

                                </Grid>
                            ))
                        }
                    </Grid>

                )}
            />


        )
    }
}

// *********************
// Type
// *********************
type Props = {
    // 菜品详情
    detail: MenuDish;
    // 返回
    handleClickBack: () => void;
    // 切换显示模式
    handleChangeMode: () => void;
    // 刷新菜单数据
    getMenuData: () => void;
    // 税率组
    taxGroup: TaxGroup[];
    // 不同菜单同一菜品
    dishes: MenuDish[];
}
type State = {
    // 不同菜单同一菜品
    dishes: MenuDish[];
}